export const colors = [
  '#0f75bd',
  '#66bb6a',
  '#29b6f6',
  '#ffee58',
  '#ef5350',
  '#868e96'
];
